import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';

import { AuthEffects } from './+state';

import { AuthRoutingModule } from './auth.routes';

import { guards } from './guards';

@NgModule({
  imports: [AuthRoutingModule],
  providers: [...guards, provideEffects(AuthEffects)]
})
export class AuthModule {}
